import { AxiosError } from 'axios';

interface PhysicalLocationValidationErrorResponse {
  errors?: Record<string, string[]>;
}

export function extractPhysicalLocationNameErrors(
  error: unknown,
  requestToOriginalIndexes?: number[]
): string[] | undefined {
  if (!(error instanceof AxiosError)) {
    return undefined;
  }

  if (error.response?.status !== 400) {
    return undefined;
  }

  const responseData = error.response.data as PhysicalLocationValidationErrorResponse;
  const fieldErrors = responseData.errors;

  if (!fieldErrors) {
    return undefined;
  }

  const nameErrors: string[] = [];

  for (const [property, messages] of Object.entries(fieldErrors)) {
    const match = /^names\.(\d+)$/.exec(property);

    if (!match || !messages[0]) {
      continue;
    }

    const requestIndex = Number(match[1]);
    const originalIndex = requestToOriginalIndexes?.[requestIndex] ?? requestIndex;

    nameErrors[originalIndex] = messages[0];
  }

  return nameErrors.some(Boolean) ? nameErrors : undefined;
}
